import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { SITE } from "../data/site";

export default function NotFound() {
  return (
    <section className="tactical-grid" data-testid="not-found">
      <Seo
        title={`Page Not Found | ${SITE.name} England`}
        description="The page you requested could not be found. Browse our security services or England locations directory."
        noindex
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-amber mb-6 flex items-center gap-3">
          <span className="w-8 h-px bg-amber"></span> 404 // Off Grid
        </p>
        <h1 className="font-display font-black uppercase leading-[0.95] tracking-tight text-5xl sm:text-7xl text-white max-w-3xl">
          This sector isn&apos;t on our map
        </h1>
        <p className="mt-6 max-w-xl text-base text-gray-400 leading-relaxed">
          The page you requested doesn&apos;t exist. Head back to base, browse our
          17 specialist security services, or find your local England security
          page.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link
            to="/"
            data-testid="notfound-home-btn"
            className="group flex items-center gap-3 bg-amber text-ink font-display font-bold uppercase tracking-widest text-sm px-7 py-4 hover:bg-white transition-colors duration-300"
          >
            Back to Base
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link
            to="/locations"
            data-testid="notfound-locations-btn"
            className="group flex items-center gap-3 border border-white/25 text-white font-display font-bold uppercase tracking-widest text-sm px-7 py-4 hover:border-amber hover:text-amber transition-colors duration-300"
          >
            England Locations
          </Link>
          <Link
            to="/services"
            data-testid="notfound-services-btn"
            className="group flex items-center gap-3 border border-white/25 text-white font-display font-bold uppercase tracking-widest text-sm px-7 py-4 hover:border-amber hover:text-amber transition-colors duration-300"
          >
            All Services
          </Link>
        </div>
      </div>
    </section>
  );
}
